<template>
  <div>
    <Top></Top>
    <!-- 上边 -->
    <div class="order-tip">
      <div class="boxWx">
        <div class="imgWx"><img src="../imgs/wxpay.svg"></div>
        <div>
          <p>微信支付</p>
        </div>
      </div>
    </div>

    <div class="box2">
      <img @click="updataCode" :src="dataSrc" class="wxCode" />
      <div class="foot">
        <p>订单已提交，请尽快完成付款</p>
        <el-button style="width:300px" @click="payOk">已完成支付</el-button>
      </div>
    </div>
    <!-- 对话框 -->
    <el-dialog center :visible.sync="dialogVisible" width="40%">
      <!-- 如果成功，用对钩图片 -->
      <img v-if="success" src="../imgs/success.png">
      <!-- 如果成功，显示此文字 -->
      <span v-if="success">恭喜！您已成为云上世界尊贵会员</span>
      <!-- 如果失败，显示此文字 -->
      <span v-else>未检测到您的支付订单，请及时支付，如支付遇到问题，请联系客服</span>
      <span slot="footer" class="dialog-footer">
        <!-- 如果成功，显示此按钮 -->
        <el-button v-if="success" @click="pushVip">进入会员中心</el-button>
        <!-- 如果失败，显示此按钮 -->
        <el-button v-else @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Top from "../components/top.vue";
export default {
  created() {
    // console.log(this.$router.resolve);
    // console.log(this.$route.query.datal);
    this.updataCode()
    // this.orderCode = this.$route.query.data.outTradeNo
    this.menuNumber = this.$route.query.menuNumber
    // console.log(this.orderCode);
  },
  data() {
    return {
      dataSrc: '',
      orderCode: '',//订单编号
      menuNumber: '', //套餐编号
      dialogVisible: false,
      success: false,//支付是否成功
    }
  },
  methods: {
    // 点击二维码更新(获取二维码)
    async updataCode() {
      const menuNumber = this.$route.query.menuNumber
      let formData = new FormData()
      formData.append('menuNumber', menuNumber)
      // console.log(formData);
      const res = await this.$axios.post('/pay/WeixinPay', formData)
      // console.log(JSON.parse(res.data));
      this.dataSrc = JSON.parse(res.data).qrCode
      this.orderCode = JSON.parse(res.data).outTradeNo
    },

    // 点击已完成支付
    async payOk() {
      // console.log(this.orderCode);
      // let formData = new FormData()
      // formData.append('menuNumber', this.menuNumber)
      // formData.append('outTradeNo', this.orderCode)
      const res = await this.$axios.get('/pay/wechat/queryAndProcessOrder', { params: { outTradeNo: this.orderCode, code: 'MEMBER' } })
      console.log(res);
      this.success = res.success
      this.dialogVisible = true;
    },

    // 进入会员中心
    pushVip() {
      this.dialogVisible = false
      const { href } = this.$router.resolve({
        path: '/userIndex'
      })
      window.open(href, '_blank')
    },
  },

  computed: {},
  watch: {},
  filters: {},
  components: { Top }
}
</script>

<style scoped lang='scss'>
.order-tip {
  display: flex;
  align-items: center;
  min-width: 1200px;
  width: 100%;
  height: 164px;
  background-color: #f9f5f2;
  padding-left: 308px;
  margin-bottom: 50px;
}

.boxWx {
  display: flex;
  align-items: center;

  .imgWx {
    margin-right: 30px;
    width: 58px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  p {
    font-family: MicrosoftYaHei;
    font-size: 30px;
    font-weight: normal;
    line-height: 50px;
    letter-spacing: 0px;
    color: #333333;
  }
}

.box2 {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 800px;
  margin-top: 120px;

  // background-color: pink;
  .wxCode {
    width: 300px;
    height: 300px;
  }

  .foot {
    p {
      text-align: center;
      margin-bottom: 40px;
      font-size: 18px;
      font-family: MicrosoftYaHei;
    }

    .el-button {
      border-radius: 8px;
      width: 235px !important;
      background-color: #db3a3b;
      color: #fff;
    }
  }
}

/deep/ .el-dialog--center .el-dialog__body {
  text-align: center;
}

.el-button {
  background-color: #db3a3b;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/vip/payWx.vue